import { inject, provideAppInitializer } from '@angular/core';
import { PwaUpdateService } from './pwa-update.service';

/**
 * Provides proactive PWA update detection using Angular's SwUpdate.
 * Checks for updates every 5 minutes and exposes `updateAvailable` signal.
 */
export function providePwaUpdate() {
  return provideAppInitializer(() => {
    const service = inject(PwaUpdateService);
    service.initialize();
  });
}
